import AlgoliaConfig from "controller/algolia/algoliaConfig";
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';
import algoliaSearch from "algoliasearch/lite";

export default class AlgoliaAutocomplete
{
    constructor()
    {
        this.algoliaConfig = new AlgoliaConfig();
    }

    debouncePromise(fn, time)
    {
        let timer = undefined;

        return function debounced(...args)
        {
            if (timer) {
                clearTimeout(timer); // Clear the timeout first if it's already defined.
            }

            return new Promise((resolve) => {
                timer = setTimeout(() => resolve(fn(...args)), time);
            });
        };
    }

    startAutocomplete()
    {
        const defaultAlgoliaStallThreshold = 200;
        const searchClient = algoliaSearch(this.algoliaConfig.appId, this.algoliaConfig.apiKey);
        const redirectUrlPlugin = createRedirectUrlPlugin();
        const searchPageURL = "/search/";
        const debounceMS = this.algoliaConfig.debounceMS;
        const debounced = this.debouncePromise((items) => Promise.resolve(items), debounceMS);
        const suggestionsIndex = this.algoliaConfig.suggestionsIndex;
        const trackingEnabled = this.algoliaConfig.isTrackingEnabled();

        if ($("#autocomplete").length) {
            autocomplete({
                container: "#autocomplete",
                // Recommended to be 300ms more than the Debounce MS value.
                stallThreshold: debounceMS > 0 ? debounceMS + 300 : defaultAlgoliaStallThreshold,
                sourceId: 'websiteHeaderSearch',
                openOnFocus: true,
                plugins: [redirectUrlPlugin],
                insights: trackingEnabled,
                onSubmit({ state }) {
                    window.location.href = searchPageURL + state.query;
                },
                getSources({ query }) {
                    return debounced([
                        {
                            sourceId: 'algoliaItems',
                            onSelect({ setIsOpen, setQuery, event, item }) {
                                setIsOpen(false);
                                setQuery(item.query);
                                window.location.href = searchPageURL + item.query;
                            },
                            getItems() {
                                return getAlgoliaResults({
                                    searchClient,
                                    queries: [{ indexName: suggestionsIndex, query}],
                                });
                            },
                            templates: {
                                item({ item, html }) {
                                    return html`<div className="aa-ItemWrapper">
                                    <div className="aa-ItemContent">
                                        <div className="aa-ItemIcon aa-ItemIcon--noBorder">
                                            <svg viewBox="0 0 24 24" fill="currentColor">
                                                <path
                                                    d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"></path>
                                            </svg>
                                        </div>
                                        <div className="aa-ItemContentBody">
                                            <div className="aa-ItemContentTitle">${item.query}</div>
                                        </div>
                                    </div>
                                    <div className="aa-ItemActions">
                                        <button className="aa-ItemActionButton"
                                                title="Fill query with &quot;${item.query}&quot;">
                                            <svg viewBox="0 0 24 24" fill="currentColor">
                                                <path
                                                    d="M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>`;
                                },
                            },
                        },
                    ]);
                },
            });
        }
    }
}